import { API, get } from "api";

export interface FilterFields {
    field: string;
    type: string;
    translation: string;
    operations: Array<{
        name: string;
        translation: string;
    }>;
}

/**
 * Get form fields
 * @param headers
 */
export const getFilterFields = async (headers: HeadersInit): Promise<FilterFields[]> => {
    const { parsedBody } = await get<{ fields: FilterFields[] }>(`${API.baseApiUrl}/creative-mappings/fields`, {
        headers,
    });

    return parsedBody?.fields || [];
};
